import MarketingLayout from '../layouts/MarketingLayout.jsx'
import SEOHead from '../components/SEOHead.jsx'
import CTAButton from '../components/CTAButton.jsx'
import BlogCard from '../components/BlogCard.jsx'
import { BLOG_POSTS } from '../data/blog.js'

const pageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  name: 'Blog KartQuiz',
  description: 'Conseils pédagogiques, comparatifs d\'outils et guides pratiques pour les enseignants et formateurs.',
  url: 'https://kartquiz.fr/blog',
  publisher: {
    '@type': 'Organization',
    name: 'KartQuiz',
    url: 'https://kartquiz.fr',
  },
}

export default function BlogIndexPage() {
  return (
    <MarketingLayout>
      <SEOHead
        title="Blog KartQuiz — Conseils pour les profs | KartQuiz"
        description="Comparatifs d'outils, guides pédagogiques et conseils pratiques pour rendre tes cours plus engageants."
        canonical="https://kartquiz.fr/blog"
        jsonLd={[pageJsonLd]}
      />

      {/* Hero */}
      <section className="bg-[#F8FAFC] py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 text-center space-y-5">
          <p className="text-kart-action font-semibold text-sm uppercase tracking-widest">Blog</p>
          <h1 className="font-display font-semibold text-4xl md:text-5xl text-kart-night">
            Ressources pour les profs
          </h1>
          <p className="text-slate-500 text-xl leading-relaxed">
            Comparatifs d'outils, techniques pédagogiques actives, guides pratiques — pour rendre tes cours plus engageants sans y passer tes soirées.
          </p>
        </div>
      </section>

      {/* Articles grid */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {BLOG_POSTS.map(post => (
              <BlogCard key={post.slug} post={post} />
            ))}
          </div>

          {BLOG_POSTS.length === 0 && (
            <p className="text-center text-slate-400 py-20">Les premiers articles arrivent bientôt.</p>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-kart-night py-20">
        <div className="max-w-3xl mx-auto px-6 text-center space-y-6">
          <h2 className="font-display font-semibold text-3xl text-white">
            Envie de tester KartQuiz en classe ?
          </h2>
          <p className="text-slate-300">
            Un compte gratuit, 30 secondes, et ta première partie peut démarrer.
          </p>
          <CTAButton to="/login" size="lg">Créer un compte gratuit</CTAButton>
        </div>
      </section>
    </MarketingLayout>
  )
}
